import React from 'react'

const Loader = () => {
	return (
		<div className="flex items-center justify-center w-full h-[100vh] bg-gray-100 text-gray-950">
			<div>
				<h1 className="text-xl md:text-7xl font-bold flex items-center">L<svg stroke="currentColor" fill="currentColor" strokeWidth="0"
					viewBox="0 0 24 24" className="animate-spin" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-phone" viewBox="0 0 16 16">
						<path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
						<path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
					</svg>
				</svg> ading . . .</h1>
			</div>
		</div>
	)
}

export default Loader
